
import { kramerMediaArray } from './kramerMedia'
import { georgeReviewerProfile, jerryReviewerProfile, elaineReviewerProfile } from './kramerReviewers'
import { kramerBio, elaineBio, jerryBio, georgeBio } from './kramerBios'
import { kramerDatingProfileHinge, kramerDatingProfileBumble, kramerDatingProfileTinder } from './kramerDatingProfiles'

export const kramerUser = {
  _id: 'kramerUserId',
  email: 'kramer@email.com',
  acceptedTOS: true,
  subscriptionIsActive: true,
  isReviewer: false,
  reviewerProfilesToSelectFrom: [
    { ...georgeReviewerProfile },
    { ...jerryReviewerProfile },
    { ...elaineReviewerProfile }
  ],
  media: [ ...kramerMediaArray ],
  bio: { ...kramerBio },
  datingProfiles: [
    { ...kramerDatingProfileHinge },
    { ...kramerDatingProfileBumble },
    { ...kramerDatingProfileTinder }
  ],
  reviewerProfile: {},
}

export const georgeUser = {
  _id: 'georgeUserId',
  email: 'george@email.com',
  acceptedTOS: true,
  subscriptionIsActive: true,
  isReviewer: true,
  reviewerProfilesToSelectFrom: [],
  media: [],
  bio: { ...georgeBio },
  datingProfiles: [],
  reviewerProfile: { ...georgeReviewerProfile },
}

export const jerryUser = {
  _id: 'jerryUserId',
  email: 'jerry@email.com',
  acceptedTOS: true,
  subscriptionIsActive: true,
  isReviewer: true,
  reviewerProfilesToSelectFrom: [],
  media: [],
  bio: { ...jerryBio },
  datingProfiles: [],
  reviewerProfile: { ...jerryReviewerProfile },
}

export const elainekramerUser = {
  _id: 'elaineUserId',
  email: 'elaine@email.com',
  acceptedTOS: true,
  subscriptionIsActive: true,
  isReviewer: true,
  reviewerProfilesToSelectFrom: [],
  media: [],
  bio: { ...elaineBio },
  datingProfiles: [],
  reviewerProfile: { ...elaineReviewerProfile },
}
